import LoginSignUp from './LoginSignUp.component';

export default LoginSignUp;
